module.exports = __webpack_public_path__ + "img/benefit2.347659ce.png";